<label *ngIf="(items$ | async)?.length > 1 && (items$ | async) as items">
  <span>{{ label$ | async }}</span>
  <!-- <select (change)="active = $event.target.value" #context>
    <option *ngFor="let item of items" value="{{ item.isocode }}" 
      [selected]="(activeItem$ | async) === item.isocode">
      {{ item.label }}
    </option>
  </select> -->
  <div *ngIf="activeItem$ | async as activeItem" class="none">
    <div *ngFor="let item of items">
      <div class="context-selected" *ngIf="activeItem == item.isocode" (click)="openContext()">{{item.label}}<i class="material-icons bottom-arrow">keyboard_arrow_down</i></div>
    </div>
    <div *ngIf="openContectDrp" (clickOutside)="closeMenu($event)" class='context-menu' [exclude]="'div,.context-selected'">
      <div *ngFor="let item of items" (click)="active = item.isocode" [ngClass]="activeItem === item.isocode ? 'active' : ''" class="context-individual">
        {{item.label}}
      </div>
    </div>
  </div>
  
</label>